// extracted by mini-css-extract-plugin
module.exports = {"btnX":"btnX__1pLZq","horizontal3LinesMenuButton":"horizontal3LinesMenuButton__2UzYy","stylelessButton":"stylelessButton__2WNOs","rewardsCTA":"rewardsCTA__zQjBM"};